// extracted by mini-css-extract-plugin
module.exports =  {"root":"R1a3GGegfLL3_Hqvsyxz"};